<h2 mat-dialog-title>Import {{ title }}</h2>

<mat-dialog-content class="ti-body">
  <div class="br-alert br-alert--danger br-mb-2" *ngIf="error"
       data-test="dialog-error">{{ error }}</div>

  <ng-container [ngSwitch]="step">

    <div *ngSwitchCase="'file'" class="ti-choose">
      <p class="br-text-muted">
        Nothing is written until you have read what the file would do.
      </p>
      <input type="file" class="br-form-control" [attr.accept]="accepted || null"
             [disabled]="busy || !schema"
             (change)="chooseFile($any($event.target).files?.[0] ?? null)"
             data-test="choose-file" />
      <p class="br-text-muted br-small" *ngIf="busy">Reading the file…</p>
    </div>

    <app-import-mapping-step *ngSwitchCase="'mapping'"
      [mapping]="plan!.mapping" [schema]="schema!"
      [choice]="mappingChoice" (choiceChange)="chooseMapping($event)"
      [constants]="mappingConstants" (constantsChange)="chooseConstants($event)"
      [settledByHand]="mappingTouched"
      [remember]="rememberMapping" (rememberChange)="rememberMapping = $event"
      [notice]="mappingNotice" [busy]="savingMapping"
      (save)="saveMapping()" (load)="loadMapping()">
    </app-import-mapping-step>

    <app-import-plan-step *ngSwitchCase="'plan'"
      [plan]="plan!" [schema]="schema!"
      [decisions]="decisions" (decisionsChange)="decisions = $event">
    </app-import-plan-step>

    <app-import-result-step *ngSwitchCase="'result'"
      [result]="result!" [schema]="schema!" [sourceFileName]="fileName"
      [undoing]="undoing" (undoRequested)="undo()">
    </app-import-result-step>

  </ng-container>
</mat-dialog-content>

<mat-dialog-actions class="ti-actions">
  <span class="br-text-muted br-small ti-where" *ngIf="fileName">
    {{ fileName }}
  </span>

  <span class="ti-spacer"></span>

  <button type="button" class="br-btn br-btn--outline" (click)="close()">
    {{ step === 'result' ? 'Close' : 'Cancel' }}
  </button>

  <button type="button" class="br-btn br-btn--primary"
          *ngIf="step === 'mapping'" [disabled]="!canLeaveMapping"
          (click)="continueFromMapping()" data-test="continue-from-mapping">
    {{ busy ? 'Reading…' : 'See what this would do' }}
  </button>

  <ng-container *ngIf="step === 'plan'">
    <button type="button" class="br-btn br-btn--outline" [disabled]="busy"
            (click)="backToMapping()" data-test="back-to-mapping">
      Back to columns
    </button>
    <!-- How far the writing has got. Shown only while a job is running: the
         apply is a background job now, because a large file takes far longer
         than the sixty seconds nginx leaves a proxied request open. -->
    <div class="ti-progress" *ngIf="busy && applyJobId" data-test="apply-progress">
      <div class="ti-progress-bar">
        <div class="ti-progress-fill" [style.width.%]="applyPercent"></div>
      </div>
      <span class="br-text-muted br-small">
        {{ applyDone }} of {{ applyTotal }} rows written
      </span>
    </div>

    <button type="button" class="br-btn br-btn--primary" [disabled]="busy"
            (click)="apply()" data-test="apply-plan">
      {{ busy ? 'Importing…' : 'Import' }}
    </button>
  </ng-container>
</mat-dialog-actions>
